import React, { useEffect, useState } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';

/**
 * OAuth Callback Page
 *
 * Handles the OAuth redirect from Google and communicates the result
 * back to the opener window (popup flow) or redirects to home (fallback).
 */
export default function OAuthCallback() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [status, setStatus] = useState('Processing...');

  useEffect(() => {
    const code = searchParams.get('code');
    const error = searchParams.get('error');
    const state = searchParams.get('state');

    // If opened in a popup, send message to parent window
    if (window.opener) {
      window.opener.postMessage({
        type: 'google-auth-callback',
        code,
        error,
        state
      }, window.location.origin);

      setStatus('Completing sign-in...');

      // Close the popup after a short delay
      setTimeout(() => {
        window.close();
      }, 500);
    } else {
      // Not in popup - redirect to home with auth params
      // The GoogleAuthGate will handle the code from URL params
      if (code) {
        setStatus('Redirecting...');
        navigate(`/?code=${code}${state ? `&state=${state}` : ''}`);
      } else if (error) {
        setStatus(`Authentication failed: ${error}`);
        setTimeout(() => {
          navigate(`/?error=${error}`);
        }, 2000);
      } else {
        setStatus('No authentication data received');
        setTimeout(() => {
          navigate('/');
        }, 2000);
      }
    }
  }, [searchParams, navigate]);

  return (
    <div style={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      minHeight: '100vh',
      background: 'linear-gradient(135deg, #1e3a5f 0%, #0d2847 100%)',
      color: 'white',
      fontFamily: 'Inter, system-ui, sans-serif'
    }}>
      <div style={{
        background: 'white',
        borderRadius: '16px',
        padding: '48px 40px',
        textAlign: 'center',
        boxShadow: '0 25px 50px -12px rgba(0, 0, 0, 0.25)'
      }}>
        <div style={{
          width: '40px',
          height: '40px',
          border: '3px solid rgba(30, 58, 95, 0.2)',
          borderTopColor: '#1a91da',
          borderRadius: '50%',
          animation: 'spin 0.8s linear infinite',
          margin: '0 auto 20px'
        }} />
        <p style={{
          color: '#1e3a5f',
          fontSize: '1rem',
          margin: 0
        }}>
          {status}
        </p>
      </div>

      <style>{`
        @keyframes spin {
          to { transform: rotate(360deg); }
        }
      `}</style>
    </div>
  );
}
